import type * as Types from '../../__generated__/types';

import { gql } from '@apollo/client';
import { ApprovalsOnObjectCardFragmentFragmentDoc } from '../../components/common/ModularObject/Card/ApprovalsOnObjectCardFragment.generated';
import { ScheduleBaseDependencyFragmentDoc } from './dependency.generated';
export type ObjectCardObjectFragment = { __typename?: 'ModularObject', id: string, approvalsEnabled: boolean | null, durationLocked: boolean | null, assigneeId: string | null, createdAt: any | null, createdById: string | null, customFields: any | null, data: any | null, deactivated: boolean | null, deletedAt: any | null, imageId: string | null, modifiedAt: any | null, lValue: number | null, name: string | null, ownerId: string | null, resourceCost: string | null, startDate: any | null, startDateLocked: boolean | null, targetDate: any | null, targetDateLocked: boolean | null, templateId: string | null, totalResourceCost: number | null, visibility: string | null, parentsPendingAddApproval: Array<{ __typename?: 'HardwareIntegrationApproval', id: string, onTo: { __typename?: 'ModularObject', id: string, name: string | null } | null }> | null, parentsPendingRemoveApproval: Array<{ __typename?: 'HardwareIntegrationApproval', id: string, offOf: { __typename?: 'ModularObject', id: string, name: string | null } | null }> | null, approvals: Array<{ __typename?: 'Approval', id: string, approvalType: Types.ApprovalTypes, status: Types.ApprovalStatus, referenceType: string, referenceName: string, referenceParentName: string, requestedBy: { __typename?: 'User', id: string }, requestedChanges: Array<{ __typename?: 'ApprovalRequestChange', field: string, fieldId: string, to: string, from: string } | null> }> | null, blockedBy: Array<{ __typename?: 'Dependency', id: string }> | null, blocking: Array<{ __typename?: 'Dependency', id: string }> | null, children: Array<{ __typename?: 'ModularObject', id: string, name: string | null, ownerId: string | null, shares: Array<{ __typename?: 'Share', id: string | null, userId: string | null, role: Types.ShareRole | null }> | null, template: { __typename?: 'Template', id: string | null, type: Types.TemplateTypes | null } | null }> | null, comments: Array<{ __typename?: 'Comment', id: string }> | null, dependencies: Array<{ __typename?: 'Dependency', id: string, blockType: Types.DependencyBlockType | null }> | null, diffs: Array<{ __typename?: 'Diff', id: string, diffType: Types.DiffType | null, diff: { __typename?: 'FromTo', from: any | null, to: any | null, displayNames: any | null } }> | null, duration: { __typename?: 'ModularObjectDuration', startDate: any | null, targetDate: any | null } | null, externalLink: { __typename?: 'ObjectToActivateLink', objectID: string | null } | null, files: Array<{ __typename?: 'File', id: string, name: string, location: string, externalId: string, externalType: string, createdAt: any | null, revision: number | null, approved: boolean | null, tags: Array<string | null> | null }> | null, documents: Array<{ __typename?: 'Document', id: string, name: string, url: string, type: string, modularObjectId: string, externalId: string, parentName: string | null, parentType: string | null, approved: boolean | null, createdAt: any, createdById: string, createdBy: { __typename?: 'User', id: string, firstName: string | null, lastName: string | null, profileImage: string | null, organizationId: string | null } | null }> | null, historicalUpdates: Array<{ __typename?: 'ModularObjectHistoryUpdate', id: string }> | null, integrations: Array<{ __typename?: 'HardwareIntegration', id: string, objectId: string, objectType: string, parentId: string | null, parentType: string | null, createdById: string | null, createdAt: any | null, modifiedAt: any | null, deletedAt: any | null, isPending: boolean | null }> | null, owner: { __typename?: 'User', id: string, organizationId: string | null, firstName: string | null, lastName: string | null } | null, parent: { __typename?: 'ModularObject', id: string, assigneeId: string | null, name: string | null, ownerId: string | null, startDate: any | null, targetDate: any | null, owner: { __typename?: 'User', id: string, organizationId: string | null } | null, template: { __typename?: 'Template', id: string | null, type: Types.TemplateTypes | null, name: string | null } | null } | null, shares: Array<{ __typename?: 'Share', id: string | null, userId: string | null, role: Types.ShareRole | null }> | null, drivers: { __typename?: 'DriverConnections', edges: Array<{ __typename?: 'DriverEdge', node: { __typename?: 'ModularObject', id: string, assigneeId: string | null, data: any | null, name: string | null, ownerId: string | null, startDate: any | null, status: Types.DriverStatus | null, targetDate: any | null, assignee: { __typename?: 'User', id: string, email: string | null, firstName: string | null, lastName: string | null, profileImage: string | null, organizationId: string | null } | null, parent: { __typename?: 'ModularObject', id: string, name: string | null } | null, shares: Array<{ __typename?: 'Share', id: string | null, userId: string | null, role: Types.ShareRole | null }> | null, drivers: { __typename?: 'DriverConnections', edges: Array<{ __typename?: 'DriverEdge', node: { __typename?: 'ModularObject', id: string } }> } | null, template: { __typename?: 'Template', id: string | null, type: Types.TemplateTypes | null, modules: any | null, name: string | null } | null } }> } | null, template: { __typename?: 'Template', id: string | null, type: Types.TemplateTypes | null, name: string | null, modules: any | null, subType: Types.TemplateSubTypes | null } | null };

export type ScheduleModularObjectFragment = { __typename?: 'ModularObject', id: string, name: string | null, startDate: any | null, targetDate: any | null, lValue: number | null, assigneeId: string | null, status: Types.DriverStatus | null, statusModuleId: string | null, durationLocked: boolean | null, startDateLocked: boolean | null, targetDateLocked: boolean | null, modifiedAt: any | null, createdAt: any | null, templateId: string | null, ownerId: string | null, visibility: string | null, approvalsEnabled: boolean | null, deactivated: boolean | null, permission: Types.Permission | null, assignee: { __typename?: 'User', id: string, email: string | null, organizationId: string | null, firstName: string | null, lastName: string | null } | null, duration: { __typename?: 'ModularObjectDuration', startDate: any | null, targetDate: any | null } | null, template: { __typename?: 'Template', id: string | null, name: string | null, subType: Types.TemplateSubTypes | null, type: Types.TemplateTypes | null } | null, owner: { __typename?: 'User', id: string, email: string | null, organizationId: string | null, firstName: string | null, lastName: string | null } | null, dependencies: Array<{ __typename?: 'Dependency', id: string, modularObjectId: string | null, blockedById: string | null, blockType: Types.DependencyBlockType | null, activeAt: any | null, gapDays: number | null, gapMonths: number | null, gapYears: number | null }> | null, parent: { __typename?: 'ModularObject', id: string, name: string | null, template: { __typename?: 'Template', id: string | null, type: Types.TemplateTypes | null, name: string | null } | null, duration: { __typename?: 'ModularObjectDuration', startDate: any | null, targetDate: any | null } | null } | null, shares: Array<{ __typename?: 'Share', id: string | null, role: Types.ShareRole | null, userId: string | null, user: { __typename?: 'User', id: string, organizationId: string | null } | null }> | null, blockedBy: Array<{ __typename?: 'Dependency', id: string, modularObjectId: string | null, blockedById: string | null, blockType: Types.DependencyBlockType | null, gapYears: number | null, gapMonths: number | null, gapDays: number | null, calculatedGapDays: number | null, hasPendingApproval: boolean | null, blockedBy: { __typename?: 'ModularObject', id: string, name: string | null, startDateLocked: boolean | null, targetDateLocked: boolean | null, owner: { __typename?: 'User', id: string, organizationId: string | null } | null, template: { __typename?: 'Template', id: string | null, name: string | null } | null } | null }> | null, blocking: Array<{ __typename?: 'Dependency', id: string, modularObjectId: string | null, blockedById: string | null, blockType: Types.DependencyBlockType | null, gapYears: number | null, gapMonths: number | null, gapDays: number | null, calculatedGapDays: number | null, hasPendingApproval: boolean | null, modularObject: { __typename?: 'ModularObject', id: string, name: string | null, startDateLocked: boolean | null, targetDateLocked: boolean | null, owner: { __typename?: 'User', id: string, organizationId: string | null } | null, template: { __typename?: 'Template', id: string | null, name: string | null } | null } | null }> | null };

export type ScheduleModularObjectChildrenFragment = { __typename?: 'ModularObject', id: string, name: string | null, permission: Types.Permission | null, startDate: any | null, targetDate: any | null, modifiedAt: any | null, createdAt: any | null, ownerId: string | null, status: Types.DriverStatus | null, statusModuleId: string | null, template: { __typename?: 'Template', id: string | null, type: Types.TemplateTypes | null, subType: Types.TemplateSubTypes | null, name: string | null } | null, children: Array<{ __typename?: 'ModularObject', id: string, name: string | null, permission: Types.Permission | null, startDate: any | null, targetDate: any | null, modifiedAt: any | null, template: { __typename?: 'Template', id: string | null, type: Types.TemplateTypes | null, subType: Types.TemplateSubTypes | null, name: string | null } | null }> | null, shares: Array<{ __typename?: 'Share', id: string | null, role: Types.ShareRole | null, userId: string | null, user: { __typename?: 'User', id: string, organizationId: string | null } | null }> | null, parent: { __typename?: 'ModularObject', id: string } | null };

export type BaseDependencyFragment = { __typename?: 'Dependency', id: string, modularObjectId: string | null, blockedById: string | null, blockType: Types.DependencyBlockType | null, gapYears: number | null, gapMonths: number | null, gapDays: number | null, calculatedGapDays: number | null, hasPendingApproval: boolean | null };

export type BlockingDependencyFragment = { __typename?: 'Dependency', id: string, modularObjectId: string | null, blockedById: string | null, blockType: Types.DependencyBlockType | null, gapYears: number | null, gapMonths: number | null, gapDays: number | null, calculatedGapDays: number | null, hasPendingApproval: boolean | null, modularObject: { __typename?: 'ModularObject', id: string, name: string | null, startDateLocked: boolean | null, targetDateLocked: boolean | null, owner: { __typename?: 'User', id: string, organizationId: string | null } | null, template: { __typename?: 'Template', id: string | null, name: string | null } | null } | null };

export type BlockedByDependencyFragment = { __typename?: 'Dependency', id: string, modularObjectId: string | null, blockedById: string | null, blockType: Types.DependencyBlockType | null, gapYears: number | null, gapMonths: number | null, gapDays: number | null, calculatedGapDays: number | null, hasPendingApproval: boolean | null, blockedBy: { __typename?: 'ModularObject', id: string, name: string | null, startDateLocked: boolean | null, targetDateLocked: boolean | null, owner: { __typename?: 'User', id: string, organizationId: string | null } | null, template: { __typename?: 'Template', id: string | null, name: string | null } | null } | null };

export const ObjectCardObjectFragmentDoc = gql`
    fragment ObjectCardObject on ModularObject {
  id
  approvalsEnabled
  durationLocked
  assigneeId
  createdAt
  createdById
  customFields
  data
  deactivated
  deletedAt
  imageId
  modifiedAt
  lValue
  name
  ownerId
  resourceCost
  startDate
  startDateLocked
  targetDate
  targetDateLocked
  templateId
  parentsPendingAddApproval {
    id
    onTo {
      id
      name
    }
  }
  parentsPendingRemoveApproval {
    id
    offOf {
      id
      name
    }
  }
  totalResourceCost
  visibility
  approvals {
    ...ApprovalsOnObjectCardFragment
  }
  blockedBy {
    id
  }
  blocking {
    id
  }
  children {
    id
    name
    ownerId
    shares {
      id
      userId
      role
    }
    template {
      id
      type
    }
  }
  comments {
    id
  }
  dependencies {
    id
    blockType
  }
  diffs {
    id
    diffType
    diff {
      from
      to
      displayNames
    }
  }
  duration {
    startDate
    targetDate
  }
  externalLink {
    objectID
  }
  files {
    id
    name
    location
    externalId
    externalType
    createdAt
    revision
    approved
    tags
  }
  documents {
    id
    name
    url
    type
    modularObjectId
    externalId
    parentName
    parentType
    approved
    createdAt
    createdBy {
      id
      firstName
      lastName
      profileImage
      organizationId
    }
    createdById
  }
  historicalUpdates {
    id
  }
  integrations {
    id
    objectId
    objectType
    parentId
    parentType
    createdById
    createdAt
    modifiedAt
    deletedAt
    isPending
  }
  owner(includeDeleted: true) {
    id
    organizationId
    firstName
    lastName
  }
  parent {
    id
    assigneeId
    name
    ownerId
    owner(includeDeleted: true) {
      id
      organizationId
    }
    startDate
    targetDate
    template {
      id
      type
      name
    }
  }
  shares {
    id
    userId
    role
  }
  drivers(input: {includeDriverRollup: true}) {
    edges {
      node {
        id
        assigneeId
        assignee {
          id
          email
          firstName
          lastName
          profileImage
          organizationId
        }
        data
        name
        ownerId
        parent {
          id
          name
        }
        startDate
        status
        targetDate
        shares {
          id
          userId
          role
        }
        drivers {
          edges {
            node {
              id
            }
          }
        }
        template {
          id
          type
          modules
          name
        }
      }
    }
  }
  template {
    id
    type
    name
    modules
    subType
  }
}
    ${ApprovalsOnObjectCardFragmentFragmentDoc}`;
export const BaseDependencyFragmentDoc = gql`
    fragment BaseDependency on Dependency {
  id
  modularObjectId
  blockedById
  blockType
  gapYears
  gapMonths
  gapDays
  calculatedGapDays
  hasPendingApproval
}
    `;
export const BlockedByDependencyFragmentDoc = gql`
    fragment BlockedByDependency on Dependency {
  ...BaseDependency
  blockedBy {
    id
    name
    startDateLocked
    targetDateLocked
    owner(includeDeleted: true) {
      id
      organizationId
    }
    template {
      id
      name
    }
  }
}
    ${BaseDependencyFragmentDoc}`;
export const BlockingDependencyFragmentDoc = gql`
    fragment BlockingDependency on Dependency {
  ...BaseDependency
  modularObject {
    id
    name
    startDateLocked
    targetDateLocked
    owner(includeDeleted: true) {
      id
      organizationId
    }
    template {
      id
      name
    }
  }
}
    ${BaseDependencyFragmentDoc}`;
export const ScheduleModularObjectFragmentDoc = gql`
    fragment ScheduleModularObject on ModularObject {
  id
  name
  startDate
  targetDate
  lValue
  assigneeId
  status
  statusModuleId
  durationLocked
  startDateLocked
  targetDateLocked
  modifiedAt
  createdAt
  assignee(includeDeleted: true) {
    id
    email
    organizationId
    firstName
    lastName
  }
  duration {
    startDate
    targetDate
  }
  templateId
  template {
    id
    name
    subType
    type
  }
  ownerId
  owner(includeDeleted: true) {
    id
    email
    organizationId
    firstName
    lastName
  }
  visibility
  approvalsEnabled
  deactivated
  dependencies {
    ...ScheduleBaseDependency
  }
  parent {
    id
    name
    template {
      id
      type
      name
    }
    duration {
      startDate
      targetDate
    }
  }
  shares {
    id
    role
    userId
    user {
      id
      organizationId
    }
  }
  permission
  blockedBy {
    ...BlockedByDependency
  }
  blocking {
    ...BlockingDependency
  }
}
    ${ScheduleBaseDependencyFragmentDoc}
${BlockedByDependencyFragmentDoc}
${BlockingDependencyFragmentDoc}`;
export const ScheduleModularObjectChildrenFragmentDoc = gql`
    fragment ScheduleModularObjectChildren on ModularObject {
  id
  name
  permission
  startDate
  targetDate
  modifiedAt
  createdAt
  ownerId
  status
  statusModuleId
  template {
    id
    type
    subType
    name
  }
  children {
    id
    name
    permission
    startDate
    targetDate
    modifiedAt
    template {
      id
      type
      subType
      name
    }
  }
  shares {
    id
    role
    userId
    user {
      id
      organizationId
    }
  }
  parent {
    id
  }
}
    `;